<ng-container *ngIf="phase !== 'hidden'">
    <div class="welcome-splash__backdrop" aria-hidden="true"></div>

    <div class="welcome-splash__stage"
         role="status"
         aria-live="polite"
         [attr.aria-label]="ariaLabel">

        <div class="welcome-splash__sky" aria-hidden="true"></div>
        <div class="welcome-splash__stars" aria-hidden="true" *ngIf="timeOfDay === 'night'">
            <span *ngFor="let s of [0,1,2,3,4,5,6,7,8,9,10,11]" class="welcome-splash__star"></span>
        </div>

        <div class="welcome-splash__sun" aria-hidden="true"></div>
        <div class="welcome-splash__sun-halo" aria-hidden="true"></div>

        <div class="welcome-splash__water" aria-hidden="true">
            <div class="welcome-splash__water-glow"></div>
            <div class="welcome-splash__reflection"></div>
        </div>

        <div class="welcome-splash__horizon" aria-hidden="true"></div>

        <div class="welcome-splash__content">
            <div class="welcome-splash__logo-wrap">
                <img class="welcome-splash__logo"
                     [src]="logoSrc"
                     alt="Up2Boat">
            </div>

            <div class="welcome-splash__greeting">
                <div class="welcome-splash__greeting-line">
                    <ng-container *ngIf="hasName; else greetingWithoutName"
                    ><span class="welcome-splash__greeting-label">{{ greetingLine }}&nbsp;</span
                    ><span class="welcome-splash__greeting-name">{{ displayedName }}</span
                    ><span class="welcome-splash__caret"
                           aria-hidden="true"
                           *ngIf="!(displayedName === firstName && phase !== 'enter')">|</span
                    ></ng-container>
                    <ng-template #greetingWithoutName>
                        <span class="welcome-splash__greeting-label">{{ greetingLineNoName }}</span>
                    </ng-template>
                </div>
                <div class="welcome-splash__headline">{{ headline }}</div>
            </div>
        </div>
    </div>
</ng-container>
